import { render, staticRenderFns } from "./AddCustomerCare.vue?vue&type=template&id=fa461fd2&"
import script from "./AddCustomerCare.vue?vue&type=script&lang=js&"
export * from "./AddCustomerCare.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerCare.vue?vue&type=style&index=0&id=fa461fd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports